import script from "./BackupView.vue?vue&type=script&setup=true&lang=js"
export * from "./BackupView.vue?vue&type=script&setup=true&lang=js"

import "./BackupView.vue?vue&type=style&index=0&id=232817ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-232817ab"]])

export default __exports__